const validate = (values) => {
  const errors = {};
  if (!values.name) {
    errors.name = 'Esse campo não pode ficar vazio';
  }
  if (!values.shortName) {
    errors.shortName = 'Esse campo não pode ficar vazio';
  }
  if (!values.course) {
    errors.course = 'Esse campo não pode ficar vazio';
  }
  if (!values.term) {
    errors.term = 'Selecione o período letivo da turma';
  }

  if (!values.schoolGrade) {
    errors.schoolGrade = 'Selecione o nível desta turma';
  }
  if (values.cameraUrl) {
    if (!values.cameraUrl.toUpperCase().startsWith('HTTP')) {
      errors.cameraUrl = 'Url inválida';
    }
  }
  if (!values.courseStep) {
    errors.courseStep = 'Esse campo não pode ficar vazio';
  }
  if (values.singleClassShift) {
    if (!values.classShift) {
      errors.classShift = 'Esse campo não pode ficar vazio';
    }
  }
  if (!values.academicCalendar) {
    errors.academicCalendar = 'Esse campo não pode ficar vazio';
  } else if (
    values.academicCalendar &&
    values.academicCalendar.calendarCycles &&
    values.courseStep
  ) {
    if (
      values.academicCalendar.calendarCycles.length <
      values.courseStep.cycleQuantity
    ) {
      errors.academicCalendar =
        'Esse calendário possui menos ciclos do que a etapa do curso selecionada.';
    } else if (
      values.academicCalendar.calendarCycles.length >
      values.courseStep.cycleQuantity
    ) {
      errors.academicCalendar =
        'Esse calendário possui mais ciclos do que a etapa do curso selecionada.';
    }
  }

  if (values.cardsSubjects) {
    if (
      values.cardsSubjects.length &&
      !values.cardsSubjects.every((item) => item.professor && item.room)
    ) {
      errors.cardsSubjects = 'Preencha os cartões até ficarem verdes';
    }
    if (
      values.cardsSubjects.length &&
      values.cardsSubjects.every((item) => item.stepWorkLoad !== 0)
    ) {
      if (
        values.cardsSubjects.length &&
        !values.cardsSubjects.every((item) => item.restStep === 0)
      ) {
        errors.timetableGrid = 'Distribua os cartões no grid';
      }
    }
  }

  return errors;
};

export default validate;
